var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { align: "rigth" } }, [
    _c("div", { staticClass: "vx-row mb-2" }, [
      _c(
        "div",
        { staticClass: "vx-col w-auto" },
        [
          _c("span", [_vm._v("Nombre:")]),
          _c("vs-input", {
            staticClass: "w-full",
            attrs: { type: "text" },
            model: {
              value: _vm.flujo.nombre,
              callback: function($$v) {
                _vm.$set(_vm.flujo, "nombre", $$v)
              },
              expression: "flujo.nombre"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "vx-col w-auto" },
        [
          _c("span", [_vm._v("Descripción:")]),
          _c("vs-input", {
            staticClass: "w-full",
            attrs: { type: "text" },
            model: {
              value: _vm.flujo.descripcion,
              callback: function($$v) {
                _vm.$set(_vm.flujo, "descripcion", $$v)
              },
              expression: "flujo.descripcion"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "vx-row mb-2" }, [
      _c(
        "div",
        { staticClass: "vx-col w-full" },
        [
          _c("span", [_vm._v("Flujo:")]),
          _c("v-select", {
            attrs: { placeholder: "Seleccionar Flujo" },
            model: {
              value: _vm.flujo.flujo,
              callback: function($$v) {
                _vm.$set(_vm.flujo, "flujo", $$v)
              },
              expression: "flujo.flujo"
            }
          })
        ],
        1
      )
    ]),
    _c("br"),
    _vm._m(0),
    _c("br"),
    _c("div", { staticClass: "vx-row mb-2" }, [
      _c(
        "div",
        { staticClass: "vx-col w-full" },
        [
          _c("span", [_vm._v("Nombre:")]),
          _c("vs-input", {
            staticClass: "w-full",
            attrs: { type: "text" },
            model: {
              value: _vm.flujo.documento.nombre,
              callback: function($$v) {
                _vm.$set(_vm.flujo.documento, "nombre", $$v)
              },
              expression: "flujo.documento.nombre"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "vx-row mb-2" }, [
      _c(
        "div",
        { staticClass: "vx-col w-full" },
        [
          _c("span", [_vm._v("Descripción:")]),
          _c("vs-textarea", {
            staticClass: "w-full",
            attrs: { height: "150px" },
            model: {
              value: _vm.flujo.documento.descripcion,
              callback: function($$v) {
                _vm.$set(_vm.flujo.documento, "descripcion", $$v)
              },
              expression: "flujo.documento.descripcion"
            }
          })
        ],
        1
      )
    ]),
    _c("br"),
    _c("br"),
    _c("div", { attrs: { align: "center" } }, [
      _c(
        "div",
        { staticClass: "margin-bot" },
        [
          _c(
            "vs-alert",
            {
              staticClass: "mensaje",
              attrs: {
                title: "Alerta",
                active: _vm.respuesta,
                color: "success"
              }
            },
            [_vm._v(" Acción realizada correctamente ")]
          ),
          _c(
            "vs-alert",
            {
              attrs: {
                title: "Alerta",
                active: _vm.respuesta == false,
                color: "danger"
              }
            },
            [
              _vm._v(
                " Error, al realizar la operación, reintente o contacte a soporte. "
              )
            ]
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "vx-row mb-2" }, [
      _c(
        "div",
        { staticClass: "vx-col w-full" },
        [
          _vm.habilitado == true
            ? _c(
                "vs-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: { color: "rgb(255, 41, 97)", type: "filled" },
                  on: {
                    click: function($event) {
                      return _vm.enviar()
                    }
                  }
                },
                [_vm._v("Enviar")]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vx-row mb-2" }, [
      _c("div", { staticClass: "vx-col w-full" }, [
        _c("h4", [_vm._v("Documento")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }